import { createFileRoute } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";
import { suspenseOptions } from "@/lib/suspense-query";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import EntityCreateForm from "../-form";
import { getGetEntityQueryOptions } from "@/requests/gen/react-query/entity";
import snakeToCamel from "@/lib/snake-to-camel";
import { EntityCrumbs } from "../-crumbs";
import numericId from "@/lib/numeric-id";

export const Route = createFileRoute("/_private/_admin/entity/$entityId/edit")({
  loader: ({ context: { queryClient }, params: { entityId } }) =>
    queryClient.ensureQueryData(getGetEntityQueryOptions(numericId(entityId))),
  component: EntityEditPage,
});

function EntityEditPage() {
  const { entityId } = Route.useParams();
  const { data: entity } = useSuspenseQuery(
    suspenseOptions(getGetEntityQueryOptions(numericId(entityId))),
  );

  return (
    <div>
      <title>{`Edit ${entity?.name || "Entity"} - Legrande Health Portal`}</title>
      <EntityCrumbs />
      <Card>
        <CardHeader>
          <CardTitle>
            {entity
              ? "Edit " + snakeToCamel(entity.entity_type)
              : "Edit Entity"}
          </CardTitle>
          <CardDescription>Enter entity details below.</CardDescription>
        </CardHeader>
        <CardContent>
          {entity && <EntityCreateForm entity={entity} />}
        </CardContent>
      </Card>
    </div>
  );
}
